import type { Context } from './types';
type Snapshot = { context: Context } | undefined;
const EMPTY_LISTINGS: Context['listings'] = [];
export const selectSearchListings = (state: Snapshot) => state?.context.listings ?? EMPTY_LISTINGS;
export const selectSearchLoading = (state: Snapshot) => state?.context.loading ?? false;
export const selectSearchListing = (state: Snapshot) => state?.context.listing;
export const selectSearchEmployerUser = (state: Snapshot) => state?.context.employerUser;
export const selectSearchPagination = (state: Snapshot) => state?.context.pagination;
export const selectSearchTabIndex = (state: Snapshot) => state?.context.tabIndex ?? 0;
export const selectSearchFilters = (state: Snapshot) => state?.context.filters;
export const selectSearchSortBy = (state: Snapshot) => state?.context.sortBy;
export const selectSearchLoadedAt = (state: Snapshot) => state?.context.loadedAt;
// The machine clears fitQuotaResetAt when the quota resets (ON_FIT_QUOTA_RESET).
export const selectFitQuotaActive = (state: Snapshot) => state?.context.fitQuotaResetAt != null;
// The ids still being scored, as one string so a selector re-renders only when the set changes.
export const selectPendingFitKey = (state: Snapshot) =>
  (state?.context.listings ?? [])
    .filter((listing) => listing.fit?.status === 'PENDING')
    .map((listing) => listing.id)
    .join(',');
// ON_REFRESH is only taken from $_VIEW, so polling has to wait for the search to be back there.
export const selectIsSearchViewing = (state: { matches(value: '$_VIEW'): boolean } | undefined) =>
  state?.matches('$_VIEW') ?? false;
